'use client'

import { CreateAccountModal } from '@/features/auth/ui/create-account/create-account-modal'
import { LoginModal } from '@/features/auth/ui/login/login-modal'
import { ForgotPasswordModal } from '../forgot-password/forgot-password-modal'
import { ResetPasswordModal } from '../reset-password/reset-password-modal'
import { VerificationModal } from '../verify-account/verification-modal'

export const AuthModals = () => {
  return (
    <>
      <LoginModal />
      <CreateAccountModal />
      <ForgotPasswordModal />
      <VerificationModal />
      <ResetPasswordModal />
    </>
  )
}
